import { logger } from '../../utils';
import { context, SlotTargeting, targetingService } from '../../services';
import { AdSlot, utils } from '../../index';

const noFillOnAdSlot = utils.queryString.get('no-fill-ad-slot');
const noFillStartRvVal = parseInt(utils.queryString.get('no-fill-start-rv-val'), 10);
// If this param is provided, then there will be a consistent no fill multiple times
const noFillEndRvVal = parseInt(utils.queryString.get('no-fill-end-rv-val'), 10) ?? 99;

const logGroup = 'gpt-provider-no-ad-fill';

export function updateTargetingInNoAdFillCode(
	adSlot: AdSlot,
	targeting: SlotTargeting,
	castedRV: string,
): SlotTargeting {
	const slotName = adSlot.getSlotName();

	if (slotName !== noFillOnAdSlot) {
		return targeting;
	}

	logger(logGroup, 'No ad fill triggered for ad slot: ', slotName);

	let src = context.get('src');
	const intParsedRv = parseInt(castedRV);
	if (intParsedRv >= noFillStartRvVal && intParsedRv <= noFillEndRvVal) {
		// Use custom src, when RV fit in optional set range from query string, forcing "no ad fill"
		logger(logGroup, 'updateGptSlotTargeting', 'Forcing no ad fill for slot ', slotName);
		src = 'externaltest';
	} else {
		// Continue with default value & no ad fills will not be forced
		logger(logGroup, 'updateGptSlotTargeting', 'Resetting src for slot ', slotName);
	}

	targetingService.set('src', src, slotName);
	targeting.src = src;

	return targeting;
}

export function fillInNoAd(adSlotName: string, targeting: SlotTargeting): SlotTargeting {
	if (adSlotName !== noFillOnAdSlot) {
		return targeting;
	}
	if (noFillStartRvVal !== 1 || Number(targeting.rv) !== 1) {
		return targeting;
	}

	logger(
		logGroup,
		'fillInCallback',
		'Forcing no ad fill for slot ',
		adSlotName,
		' on rv === ',
		targeting.rv,
	);
	targetingService.set('src', 'externaltest', adSlotName);
	targeting.src = 'externaltest';

	return targeting;
}
